
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    addText: {
      type: String,
      default: "Create",
    },
  },
  setup() {
    return {};
  },
});
